import axios from "axios";

const headers = (token) => ({ Authorization: `Bearer ${token}` });

export const getFashionBanner = (token) =>
  axios.get(`${process.env.REACT_APP_API_URL_USER}/getFashionBanner`, {
    headers: headers(token),
  });

export const getFashionShowcase = (token, designerId) =>
  axios.get(
    `${process.env.REACT_APP_API_URL_USER}/getFashionShowcase?designerId=${designerId}`,
    { headers: headers(token) }
  );

export const getFashionLeaderboard = (token, designerId) =>
  axios.get(
    `${process.env.REACT_APP_API_URL_USER}/getFashionLeaderboard?designerId=${designerId}`,
    { headers: headers(token) }
  );

export const getFashionDesigns = (token, page = 1, designerId) =>
  axios.get(
    `${process.env.REACT_APP_API_URL_USER}/getFashionDesigns?page=${page}&designerId=${designerId}`,
    { headers: headers(token) }
  );

export const getFashionDesign = (token, id) =>
  axios.get(`${process.env.REACT_APP_API_URL_USER}/getFashionDesign/${id}`, {
    headers: headers(token),
  });

export const voteFashionDesign = (token, designId) =>
  axios.post(
    `${process.env.REACT_APP_API_URL_USER}/voteFashionDesign`,
    { designId },
    { headers: headers(token) }
  );

export async function createFashionVoteCheckout(
  token,
  { designerId, packSlot, returnOrigin, returnDeepLink }
) {
  const body = { designerId, packSlot };
  if (returnDeepLink) {
    body.returnDeepLink = returnDeepLink;
  } else {
    body.returnOrigin =
      returnOrigin ||
      (typeof window !== "undefined" ? window.location.origin : undefined);
  }
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL_USER}/createFashionVoteCheckout`,
    body,
    { headers: headers(token) }
  );
  return response.data;
}

export const confirmFashionVoteSession = (token, sessionId) =>
  axios.post(
    `${process.env.REACT_APP_API_URL_USER}/confirmFashionVoteSession`,
    { sessionId },
    { headers: headers(token) }
  );

export const getMyFashionSubmission = (token) =>
  axios.get(`${process.env.REACT_APP_API_URL_USER}/getMyFashionSubmission`, {
    headers: headers(token),
  });

export const submitFashionDesign = (token, formData, onUploadProgress) =>
  axios.post(`${process.env.REACT_APP_API_URL_USER}/submitFashionDesign`, formData, {
    headers: headers(token),
    onUploadProgress,
  });
